/**
 * The language model (the Dutch expansion).
 *
 * Deliberately data-free, exactly like `lengths.ts`: this module is
 * imported by core, by the worker and by the web's main bundle, so it must
 * never pull a word list in with it. Nothing here knows what the words
 * *are* — only which languages exist and which one is the default.
 *
 * Language is the second axis of the word data, alongside length. Every
 * lookup that used to take a length now optionally takes a language too,
 * and every one of them defaults to `DEFAULT_LANGUAGE`. That default is
 * not a convenience: it is what keeps the English game — and therefore
 * every daily answer ever served, every share text and every stored
 * session — byte-for-byte what it was before Dutch existed.
 */

/** Playable languages, as BCP 47 primary subtags. */
export const SUPPORTED_LANGUAGES = ['en', 'nl'] as const;

export type Language = (typeof SUPPORTED_LANGUAGES)[number];

/** English, and not merely alphabetically: see the module comment. */
export const DEFAULT_LANGUAGE: Language = 'en';

export function isLanguage(value: unknown): value is Language {
  return typeof value === 'string' && (SUPPORTED_LANGUAGES as readonly string[]).includes(value);
}

/** The language's own name, for a language picker that shows both. */
export const LANGUAGE_NAMES: Readonly<Record<Language, string>> = {
  en: 'English',
  nl: 'Nederlands',
};
